'use client';

import { useEffect } from 'react';
import YouNeedToLogin from './YouNeedToLogin';
import NewModal from './NewModal';
import useZStore from '@/utils/useZStore';

const NewPleaseSignInModal = () => {
  const show = useZStore((state) => state.showSignInModal);

  useEffect(() => {
    const plausible = (window as any).plausible;
    if (show && plausible) {
      plausible('NewPleaseSignInModalOpened');
    }
  }, [show]);

  const handleClosed = () => {
    useZStore.setState({ showSignInModal: false });
  };

  return (
    <NewModal
      open={show}
      onOpenChange={handleClosed}
      description="Sign in to enable bookmarking, reminders, progress-tracking and more..."
    >
      <YouNeedToLogin className="border-none shadow-none" />
    </NewModal>
  );
};

export default NewPleaseSignInModal;
